export enum CallCodeType {
    Construction = 0,
    Rehab_FixFlip = 1,
    MultiFamily_Construction = 2,
    MultiFamily_FixFlip_Rehab = 3,
    Land = 4,
    Rental = 5,
    MultiFamily_Rental = 6,
    MasterNote = 7,
    SubNote = 8,
    MultiFamily_SubNote = 9,
    Bridge = 10,
    MultiFamily_Bridge = 11,
    B2R_F2R_Building_Phase = 12,
}

export const CallCodeTypeOptions = [
    {
        id: CallCodeType.Construction,
        name: '1a1. Construction (1-4 Units)',
    },
    {
        id: CallCodeType.Rehab_FixFlip,
        name: '1a1. Rehab/Fix-Flip (1-4 Units)',
    },
    {
        id: CallCodeType.Bridge,
        name: '1a1. Bridge (1-4 Units)',
    },
    {
        id: CallCodeType.MultiFamily_Construction,
        name: '1a2. Multi-family New Construction (5+ units)',
    },
    {
        id: CallCodeType.MultiFamily_FixFlip_Rehab,
        name: '1a2. Multi-family Fix Flips/Rehabs',
    },
    {
        id: CallCodeType.MultiFamily_Bridge,
        name: '1a2. Bridge (5+ Units)',
    },
    {
        id: CallCodeType.Land,
        name: '1a2. Land Loans',
    },
    {
        id: CallCodeType.Rental,
        name: '1c2a. Rental Loans (1-4 units)',
    },
    {
        id: CallCodeType.MultiFamily_Rental,
        name: '1d. Multi-family Rentals (5+ units)',
    },
    {
        id: CallCodeType.MasterNote,
        name: '1a1. Master Note SBA LOC Construction Loans',
    },
    {
        id: CallCodeType.SubNote,
        name: '1a1. Sub-note SBA LOC Construction Loans (1-4 Units)',
    },
    {
        id: CallCodeType.MultiFamily_SubNote,
        name: '1a2. Sub-note SBA LOC Construction Loans (5+ Units)',
    },
    {
        id: CallCodeType.B2R_F2R_Building_Phase,
        name: '1a1. B2R/F2R during build phase (1-4 Units)',
    },
];
